import { useSalesOrderControllerGetSalesOrderByExternalId } from '@/generated/api/sales-order.ts';
import { useMemo } from 'react';
import { Loader } from '@mantine/core';
import SidebarLink from '@/common/sidebar/SidebarLink.tsx';

export default function WorkOrderSalesOrderLink({
  salesOrderExternalId,
}: {
  salesOrderExternalId: string;
}) {
  const isValid = /^\d{6,}$/.test(salesOrderExternalId);
  const salesOrder = useSalesOrderControllerGetSalesOrderByExternalId(
    salesOrderExternalId,
    { query: { enabled: isValid } },
  );
  const salesOrderId = useMemo(
    () => salesOrder.data?.id ?? null,
    [salesOrder.data],
  );

  return salesOrder.isLoading ? (
    <Loader size="xs" />
  ) : !isValid || salesOrderId === null ? (
    salesOrderExternalId
  ) : (
    <SidebarLink
      id="salesOrderDetail"
      params={{
        salesOrderId,
        salesOrderExternalId,
        defaultTab: 'work-orders',
      }}
    >
      {salesOrderExternalId}
    </SidebarLink>
  );
}
